var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
export const AuthMonitor = (authenticated, isAuthFailure, login) => {
    // Our app code may issue multiple requests to the server which all experience
    // auth failures.  We don't want to have the user re-login for each of them, we 
    // want one login process to handle all of them.  So we cache our login task
    // here and re-use it for any requests that come in before we've finished re-
    // logging in.
    let loginTask = null;
    // requestCreds is our flag to the app view that it needs to request a user/pw
    // from the user. `null` means no need to request creds, a validation function
    // means request creds and pass them to the function.
    const requestCredentials = S.data(null);
    return { requestCredentials, requireAuth };
    // authenticate() returns a promise which won't complete until the user has 
    // successfully logged in, even if that takes several tries by the user
    function authenticate() {
        return loginTask = loginTask || new Promise(resolve => requestCredentials((username, password) => __awaiter(this, void 0, void 0, function* () {
            const u = yield login(username, password);
            if (loginTask !== null) {
                loginTask = null;
                requestCredentials(null);
                resolve(u);
            }
            return u;
        })));
    }
    /**
     * requireAuth() takes a function and returns a wrapped function with an identical call signature.
     * The wrapped function detects auth failures -- rejected Promises whose rejection value matches
     * isAuthFailure -- and calls for a login when it detects a potential or actual auth failure.
     *
     * @param fn - the function to wrap
     */
    function requireAuth(fn) {
        return (function () {
            return __awaiter(this, arguments, void 0, function* () {
                // if user hasn't authenticated yet, we need to do so before the first request
                if (authenticated()) {
                    try {
                        return yield fn(...arguments);
                    }
                    catch (e) {
                        // if request fails with an auth failure, re-authenticate() and try again.
                        if (isAuthFailure(e)) {
                            yield authenticate();
                            // if we get a second auth failure we pass it through
                            return yield fn(...arguments);
                        }
                        else {
                            throw e;
                        }
                    }
                }
                else {
                    yield authenticate();
                    return yield fn(...arguments);
                }
            });
        });
    }
};
